// Formats a duration in seconds into a human-readable "Xm Ys" string.
// Returns '—' for null/undefined values.
export function formatDuration(seconds: number | null | undefined): string {
    if (seconds === null || seconds === undefined) return '—';
    const abs  = Math.abs(seconds);
    const m    = Math.floor(abs / 60);
    const s    = abs % 60;
    const sign = seconds < 0 ? '-' : '';
    return `${sign}${m}m ${s}s`;
}

// Formats an ISO timestamp into a short date/time string in the en-ZA locale.
// Returns '—' for null/undefined values.
export function formatDateTime(iso: string | null | undefined): string {
    if (!iso) return '—';
    return new Date(iso).toLocaleString('en-ZA', {
        day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
    });
}